<template>
  <van-dialog
    v-model="showDialog"
    :show-confirm-button="false"
    :close-on-click-overlay="false"
    :show-cancel-button="false"
    class="upgrade-dialog"
  >
    <div class="upgrade-content">
      <div class="upgrade-icon">
        <van-icon :name="icon" size="48" :color="iconColor" />
      </div>
      <h3 class="upgrade-title">{{ title }}</h3>
      <p
        class="upgrade-message"
        v-for="(msg, index) in messages"
        :key="index"
      >{{ msg }}</p>
      <van-button
        type="primary"
        block
        class="upgrade-btn"
        @click="onConfirm"
      >
        {{ confirmText }}
      </van-button>
    </div>
  </van-dialog>
</template>

<script>
import { Dialog, Icon, Button } from "vant";

export default {
  name: "UpgradeDialog",
  components: {
    vanIcon: Icon,
    vanButton: Button,
    [Dialog.Component.name]: Dialog.Component,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "系统升级维护中",
    },
    messages: {
      type: Array,
      default: () => [
        "尊敬的用户：",
        "系统正在进行临时升级维护",
        "暂停下单服务",
      ],
    },
    confirmText: {
      type: String,
      default: "我知道了",
    },
    icon: {
      type: String,
      default: "warning",
    },
    iconColor: {
      type: String,
      default: "#ff9500",
    },
  },
  data() {
    return {
      showDialog: this.show,
    };
  },
  watch: {
    show(val) {
      this.showDialog = val;
    },
  },
  mounted() {
    if (this.show) {
      this.showDialog = true;
    }
  },
  methods: {
    onConfirm() {
      this.showDialog = false;
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.upgrade-dialog {
  .van-dialog {
    width: 80%;
    max-width: 300px;
    border-radius: 12px;
    overflow: hidden;
  }
}

.upgrade-content {
  padding: 20px;
  text-align: center;
  background: linear-gradient(135deg, #fff9f0 0%, #fff 100%);
}

.upgrade-icon {
  margin: 10px 0 20px;
  animation: bounce 2s infinite;
}

.upgrade-title {
  color: #ff6b00;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
}

.upgrade-message {
  color: #333;
  margin: 8px 0;
  font-size: 15px;
  line-height: 1.5;
}

.upgrade-btn {
  background: linear-gradient(to right, #ff9500, #ff6b00);
  border: none;
  border-radius: 25px;
  height: 44px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  box-shadow: 0 4px 8px rgba(255, 107, 0, 0.2);
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
</style>
